import { computed } from 'vue'
import { LANGS } from './languages'
import { useLanguageStore } from './languageStore'

const sharedComputed = {}
const sharedFunctions = {}

export function useLanguage() {
  const languageStore = useLanguageStore()

  sharedFunctions.setLanguage ??= async (language: string) =>
    await languageStore.setLanguage(language)

  sharedFunctions.switchLanguage ??= async () =>
    await sharedFunctions.setLanguage(sharedComputed.isFr.value ? LANGS.EN.id : LANGS.FR.id)

  sharedComputed.language ??= computed(() => languageStore.language)

  sharedComputed.invertLanguage ??= computed(() => languageStore.invertLanguage)

  sharedComputed.upperLanguage ??= computed(() => languageStore.upperLanguage)

  /**
   * FR
   */
  sharedFunctions.useFr ??= () => languageStore.setFr()

  sharedComputed.isFr ??= computed(() => languageStore.isFr)

  sharedComputed.nameFr ??= computed(() =>
    sharedComputed.isFr.value ? LANGS.FR.nameFr : LANGS.FR.nameEn
  )

  /**
   * EN
   */
  sharedFunctions.useEn ??= () => languageStore.setEn()

  sharedComputed.isEn ??= computed(() => languageStore.isEn)

  sharedComputed.nameEn ??= computed(() =>
    sharedComputed.isEn.value ? LANGS.EN.nameFr : LANGS.EN.nameEn
  )

  return {
    setLanguage: sharedFunctions.setLanguage,
    switchLanguage: sharedFunctions.switchLanguage,
    language: sharedComputed.language,
    invertLanguage: sharedComputed.invertLanguage,
    upperLanguage: sharedComputed.upperLanguage,
    useFr: sharedFunctions.useFr,
    isFr: sharedComputed.isFr,
    nameFr: sharedComputed.nameFr,
    useEn: sharedFunctions.useEn,
    isEn: sharedComputed.isEn,
    nameEn: sharedComputed.nameEn
  }
}
